/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateInsuredPayloadDto,
  ErrorResponse,
  InsuredFilterQueryDto,
  InsuredPaginationResponseDto,
  InsuredResponseDto,
  UpdateInsuredPayloadDto,
} from '../models/index';
import {
    CreateInsuredPayloadDtoFromJSON,
    CreateInsuredPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    InsuredFilterQueryDtoFromJSON,
    InsuredFilterQueryDtoToJSON,
    InsuredPaginationResponseDtoFromJSON,
    InsuredPaginationResponseDtoToJSON,
    InsuredResponseDtoFromJSON,
    InsuredResponseDtoToJSON,
    UpdateInsuredPayloadDtoFromJSON,
    UpdateInsuredPayloadDtoToJSON,
} from '../models/index';

export interface CreateInsuredRequest {
    createInsuredPayloadDto: CreateInsuredPayloadDto;
}

export interface DeleteInsuredByIdRequest {
    insuredId: string;
}

export interface FilterInsuredsRequest {
    insuredFilterQueryDto: InsuredFilterQueryDto;
    page?: number;
    pageSize?: number;
}

export interface FilterInsuredsClaimsRequest {
    insuredFilterQueryDto: InsuredFilterQueryDto;
    page?: number;
    pageSize?: number;
}

export interface GetInsuredByIdRequest {
    insuredId: string;
    prefetchChangelogs?: number;
}

export interface UpdateInsuredRequest {
    insuredId: string;
    updateInsuredPayloadDto: UpdateInsuredPayloadDto;
}

/**
 * 
 */
export class InsuredApi extends runtime.BaseAPI {

    /**
     * Create insured
     */
    async createInsuredRaw(requestParameters: CreateInsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InsuredResponseDto>> {
        if (requestParameters['createInsuredPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createInsuredPayloadDto',
                'Required parameter "createInsuredPayloadDto" was null or undefined when calling createInsured().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/insured`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInsuredPayloadDtoToJSON(requestParameters['createInsuredPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InsuredResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create insured
     */
    async createInsured(requestParameters: CreateInsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InsuredResponseDto> {
        const response = await this.createInsuredRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete insured by id
     */
    async deleteInsuredByIdRaw(requestParameters: DeleteInsuredByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['insuredId'] == null) {
            throw new runtime.RequiredError(
                'insuredId',
                'Required parameter "insuredId" was null or undefined when calling deleteInsuredById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/insured/{insuredId}`.replace(`{${"insuredId"}}`, encodeURIComponent(String(requestParameters['insuredId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete insured by id
     */
    async deleteInsuredById(requestParameters: DeleteInsuredByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteInsuredByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Filter insureds
     */
    async filterInsuredsRaw(requestParameters: FilterInsuredsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InsuredPaginationResponseDto>> {
        if (requestParameters['insuredFilterQueryDto'] == null) {
            throw new runtime.RequiredError(
                'insuredFilterQueryDto',
                'Required parameter "insuredFilterQueryDto" was null or undefined when calling filterInsureds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/insured/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InsuredFilterQueryDtoToJSON(requestParameters['insuredFilterQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InsuredPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter insureds
     */
    async filterInsureds(requestParameters: FilterInsuredsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InsuredPaginationResponseDto> {
        const response = await this.filterInsuredsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Filter all insureds that are eligible for claim assignment
     */
    async filterInsuredsClaimsRaw(requestParameters: FilterInsuredsClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InsuredPaginationResponseDto>> {
        if (requestParameters['insuredFilterQueryDto'] == null) {
            throw new runtime.RequiredError(
                'insuredFilterQueryDto',
                'Required parameter "insuredFilterQueryDto" was null or undefined when calling filterInsuredsClaims().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/insured/eligible-for-claims/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InsuredFilterQueryDtoToJSON(requestParameters['insuredFilterQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InsuredPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter all insureds that are eligible for claim assignment
     */
    async filterInsuredsClaims(requestParameters: FilterInsuredsClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InsuredPaginationResponseDto> {
        const response = await this.filterInsuredsClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get insured by id
     */
    async getInsuredByIdRaw(requestParameters: GetInsuredByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InsuredResponseDto>> {
        if (requestParameters['insuredId'] == null) {
            throw new runtime.RequiredError(
                'insuredId',
                'Required parameter "insuredId" was null or undefined when calling getInsuredById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['prefetchChangelogs'] != null) {
            queryParameters['prefetchChangelogs'] = requestParameters['prefetchChangelogs'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/insured/{insuredId}`.replace(`{${"insuredId"}}`, encodeURIComponent(String(requestParameters['insuredId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InsuredResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get insured by id
     */
    async getInsuredById(requestParameters: GetInsuredByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InsuredResponseDto> {
        const response = await this.getInsuredByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update insured
     */
    async updateInsuredRaw(requestParameters: UpdateInsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InsuredResponseDto>> {
        if (requestParameters['insuredId'] == null) {
            throw new runtime.RequiredError(
                'insuredId',
                'Required parameter "insuredId" was null or undefined when calling updateInsured().'
            );
        }

        if (requestParameters['updateInsuredPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateInsuredPayloadDto',
                'Required parameter "updateInsuredPayloadDto" was null or undefined when calling updateInsured().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/insured/{insuredId}`.replace(`{${"insuredId"}}`, encodeURIComponent(String(requestParameters['insuredId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInsuredPayloadDtoToJSON(requestParameters['updateInsuredPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InsuredResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update insured
     */
    async updateInsured(requestParameters: UpdateInsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InsuredResponseDto> {
        const response = await this.updateInsuredRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
